"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EquipPreview = void 0;

var _react = require("@lingui/react");

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _blocks = require("@bueno/blocks");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _dateFns = require("date-fns");

var _utils = require("../../HistoryModal/context/utils");

var _aperture = require("../../../utils/aperture");

var _tenant = require("../../../utils/tenant");

const PreviewWrapper = _styledComponents.default.div`
  position: relative;
  /* targeting the Popover */
  > div {
    top: 100%;
    width: 160px;
    transform: translateY(-100%);
  }

  .History--Link,
  .TrendGraph--Link {
    ${_blocks.typography.bodySmall}

    color: ${_blocks.color.theme.primaryColor.action.primary};
    text-decoration: none;

    display: inline-flex;
    align-items: center;
  }
`;
const Container = _styledComponents.default.div`
  position: relative;
  display: inline-block;
  max-width: 100%;

  ${PreviewWrapper} {
    display: none;
  }

  &:hover ${PreviewWrapper} {
    display: block;
  }
`;
const Padding = (0, _styledComponents.css)`
  padding: ${_blocks.spacing.tight} ${_blocks.spacing.snug};
`;
const HitInfoList = _styledComponents.default.ul`
  border-bottom: 1px solid ${_blocks.palette.neutral3};
  padding: ${_blocks.spacing.snug};
`;
const HitInfoListItem = _styledComponents.default.li`
  padding-bottom: ${_blocks.spacing.tight};
  &:last-of-type {
    padding-bottom: 0;
  }
`;
const LatestOccuredOn = _styledComponents.default.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${Padding}

  > a:hover {
    text-decoration: underline;
  }
`;

function convertTimesString(times) {
  return times.reduce((result, {
    t,
    d
  }) => {
    if (d === 86400) {
      result.push(`${t} (24hr)`);
      return result;
    }

    const dur = (0, _dateFns.intervalToDuration)({
      start: new Date(0),
      end: (0, _dateFns.addSeconds)(new Date(0), d)
    });
    result.push(`${t} (${dur.hours}hr ${dur.minutes}min)`);
    return result;
  }, []);
}

function mapStateToProps(state) {
  return {
    userSites: state.userSites
  };
}

const EquipPreview = ({
  children,
  data,
  userSites
}) => {
  const historyViewerUrl = (0, _tenant.useApertureUrl)();
  if (!data || userSites === undefined) return null;
  const site = userSites.sites[data.siteId];
  if (!site) return null;
  const occurredOnDate = React.useMemo(() => {
    const asDate = data.occurredOn !== undefined ? new Date(data.occurredOn) : new Date();
    if ((0, _dateFns.isToday)(asDate)) return 'Today';
    if ((0, _dateFns.isYesterday)(asDate)) return 'Yesterday';
    return (0, _dateFns.formatDistanceToNowStrict)(asDate, {
      addSuffix: true
    });
  }, [data.occurredOn]);
  const occurredOnRange = React.useMemo(() => {
    return (0, _utils.getHistoryDateRange)(data.occurredOn);
  }, [data.occurredOn]);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(PreviewWrapper, null, /*#__PURE__*/React.createElement(_blocks.Popover, null, /*#__PURE__*/React.createElement(HitInfoList, null, /*#__PURE__*/React.createElement(HitInfoListItem, null, /*#__PURE__*/React.createElement(_blocks.BodySmall, null, /*#__PURE__*/React.createElement("strong", null, data.targetName)), /*#__PURE__*/React.createElement(_blocks.BodySmall, null, data.description)), /*#__PURE__*/React.createElement(HitInfoListItem, null, /*#__PURE__*/React.createElement(_blocks.BodySmall, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "equip_preview.durations"
  }))), convertTimesString(data.times).length > 0 ? convertTimesString(data.times).map((time, index) => /*#__PURE__*/React.createElement(_blocks.BodySmall, {
    key: `${index} - ${time}`
  }, time)) : null), /*#__PURE__*/React.createElement(HitInfoListItem, null, /*#__PURE__*/React.createElement(_blocks.BodySmall, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "equip_preview.severity"
  }))), /*#__PURE__*/React.createElement(_blocks.BodySmall, null, data.severity))), /*#__PURE__*/React.createElement(LatestOccuredOn, null, /*#__PURE__*/React.createElement(_blocks.BodySmall, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "equip_preview.latest"
  }))), /*#__PURE__*/React.createElement("a", {
    href: (0, _aperture.getApertureHistoryLink)({
      baseUrl: historyViewerUrl,
      equipId: data.forgeId,
      occurrenceId: data.occurrenceId,
      organisationId: site.projectId,
      range: [occurredOnRange.start, occurredOnRange.end],
      ruleId: data.ruleId,
      siteId: site.forgeId
    }),
    target: "_blank",
    rel: "noopener",
    className: "History--Link"
  }, occurredOnDate, /*#__PURE__*/React.createElement(_blocks.External, {
    fillColor: _blocks.color.theme.primaryColor.action.primary
  }))))), children);
};

const Connected = (0, _reactRedux.connect)(mapStateToProps, null)(EquipPreview);
exports.EquipPreview = Connected;